module.exports = __webpack_public_path__ + "static/media/ic_rabat.2bc9f306.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_rabat.svg
// module id = 502
// module chunks = 0